import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { changeFormFieldValue, removeFieldError, setFieldError, updateFields } from 'apps/auth/actions/formAction';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import type { AppDispatch } from 'apps/auth/redux/store';

import { Input, InputContainer } from './styles';

type FormFieldValue = File | string | null | undefined;

interface UploadField {
    name: string;
    placeholder?: string;
    value?: FormFieldValue;
    isError?: boolean;
    errorMessage?: string;
    [key: string]: unknown;
}

interface UploadFileProps {
    formName: string;
    field: UploadField;
}

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const UploadFileComponent: React.FC<UploadFileProps> = (props) => {
    const dispatch = useDispatch<AppDispatch>();
    const inputFile = useRef<HTMLInputElement | null>(null);
    const [fieldTitle, setFieldTitle] = useState<string | undefined>(props.field.placeholder);

    const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const selectedFile = event.target.files?.[0];
        if (!selectedFile) {
            return;
        }
        props.field.value = selectedFile;
        const size = selectedFile.size || (selectedFile as File & { fileSize?: number }).fileSize || 0;
        void dispatch(removeFieldError(props.formName, props.field.name));
        if (size > MAX_FILE_SIZE) {
            props.field.isError = true;
            props.field.errorMessage = 'Max file size : 5Mb';
            setFieldTitle(props.field.placeholder);
            void dispatch(setFieldError(props.formName, props.field.name, props.field.errorMessage));
            return;
        }
        void dispatch(changeFormFieldValue(props.formName, selectedFile, props.field.name));
        void dispatch(updateFields(props.formName, selectedFile));
        setFieldTitle(selectedFile.name);
    };

    return (
        <div onChange={onChangeHandler}>
            <Row indent="24px">
                <Text size="subheader" color="secondary" />
            </Row>
            <InputContainer key={`file_${props.field.name}`}>
                <Row
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        inputFile.current?.click();
                    }}
                >
                    <Icon name="plus" color="primary" /> {fieldTitle}
                </Row>
                <Input type="file" className="hidden" name={props.field.name} ref={inputFile} onChange={onChangeHandler} />
            </InputContainer>
            {props.field.isError && <div className="field__error_message error-message-no-margin color-red">{props.field.errorMessage}</div>}
        </div>
    );
};

export default UploadFileComponent;
